import sanitiseHTML from 'sanitize-html';
const SANITISE_HTML_OPTIONS = {
    allowedAttributes: {
        a: ['aria-label', 'href', 'name', 'rel', 'target', 'title', 'class', 'data-contextintentid'],
        img: ['alt', 'class', 'src']
    },
    allowedSchemes: ['data', 'http', 'https', 'ftp', 'mailto', 'sip', 'tel'],
    allowedTags: [
        'a',
        'b',
        'blockquote',
        'br',
        'caption',
        'code',
        'del',
        'div',
        'em',
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6',
        'hr',
        'i',
        'img',
        'ins',
        'li',
        'nl',
        'ol',
        'p',
        'pre',
        's',
        'span',
        'strike',
        'strong',
        'table',
        'tbody',
        'td',
        'tfoot',
        'th',
        'thead',
        'tr',
        'ul'
    ]
};
export const sanitiseWebChatHTML = (html) => sanitiseHTML(html, SANITISE_HTML_OPTIONS);
//# sourceMappingURL=sanitiseWebChatHTML.js.map